import { render, staticRenderFns } from "./DesktopSearchPage.vue?vue&type=template&id=a210cbd6&scoped=true"
import script from "./DesktopSearchPage.vue?vue&type=script&lang=js"
export * from "./DesktopSearchPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopSearchPage.vue?vue&type=style&index=0&id=a210cbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210cbd6",
  null
  
)

export default component.exports